module.exports = __webpack_public_path__ + "static/img/ground2.8b5f8dd8.png";